// extracted by mini-css-extract-plugin
export default {"container":"MaintenancePage_container__kaQLZ","header":"MaintenancePage_header__QTYgV","icon":"MaintenancePage_icon__D7ZO9","message":"MaintenancePage_message__SP9NY"};